__webpack_require__.p = "//python2fun.oss-cn-beijing.aliyuncs.com/@quark-app/home/_next/";